import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { TranslatedPath } from '../../components/navigation/language-switcher/LanguageSwitcher.props';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// TODO: Add SEO props
const seo = {
  description: '',
};

const StyledFAQPage = styled(StyledInformationalPage)`
  .faq-field:not(:last-of-type) {
    margin-bottom: 3.75em;
  }

  .faq-field-question {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
  }

  .faq-field-answer {
    font-size: 1rem;
  }

  .faq-field-list {
    list-style: disc;
    padding: 0 1rem 0 2rem;
  }

  .faq-field-list-item {
    word-wrap: break-word;
  }
`;

const translatedPaths: TranslatedPath[] = [{ locale: 'fr-BE', path: '/fr/aide' }];

const title = 'Veelgestelde Vragen';

// tslint:disable:max-line-length
// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='nl-BE' seo={seo} translatedPaths={translatedPaths}>
    <HeadTitle title={title} />
    <StyledFAQPage>
      <div className='content'>
        <section>
          <h1>{title}</h1>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Wat is WarnerBros.be?</h2>
            <div className='faq-field-answer'>
              <p>
                WarnerBros.be is een website waarop je alles kunt vinden over Warner Bros. Films, Home Entertainment,
                Games en meer die in Nederland gedistribueerd worden.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Kan ik een filmpremière bijwonen?</h2>
            <div className='faq-field-answer'>
              <p>
                Filmpremières zijn enkel op basis van persoonlijke uitnodiging bij te wonen. Houd echter onze website en
                social media kanalen in de gaten, want er zijn vaak prijsvragen waarbij je toegangskaarten kunt winnen.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Hoe kan ik kaarten kopen voor de Warner Bros. Studio Tour?</h2>
            <div className='faq-field-answer'>
              <p>
                Je kan de Warner Bros. Studio's bezoeken! Om meer over de Experience te lezen en je kaarten te kopen
                bezoek je de officiële website van{' '}
                <a href='http://www.wbstudiotour.com' target='_blank'>
                  Warner Bros. Studio Tour Hollywood
                </a>{' '}
                of{' '}
                <a href='http://www.wbstudiotour.co.uk' target='_blank'>
                  Warner Bros. Studio Tour London
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Waar kan ik de openstaande vacatures vinden van Warner Bros.?</h2>
            <div className='faq-field-answer'>
              <p>
                Voor een totale lijst van openstaande vacatures bezoek je de volgende website:{' '}
                <a href='https://www.warnerbroscareers.com' target='_blank'>
                  www.warnerbroscareers.com
                </a>
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              Ik heb een idee voor een film, televisieprogramma of script. Hoe benader ik Warner Bros.?
            </h2>
            <div className='faq-field-answer'>
              <p>
                Warner Bros. Entertainment accepteert geen ideeën voor film, televisie of ander verhaalmateriaal, tenzij
                het ingezonden wordt door een gecertificeerd literair agent die is aangesloten bij de Writers Guild Of
                America. Als je geïnteresseerd bent in een lijst met geaccrediteerde agenten, bel dan met de Writers
                Guild in Amerika, telefoonnummer 323-951-4000, of stuur ze een e-mail via hun website,{' '}
                <a href='http://www.wga.org/' target='_blank'>
                  www.wga.org
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Wat is Digital HD ULTRAVIOLET?</h2>
            <div className='faq-field-answer'>
              <p>
                Bekijk je film waar jij wil op je verschillende devices! Meer informatie vind je op:{' '}
                <a href='https://nl.flixster.com' target='_blank'>
                  nl.flixster.com
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </StyledFAQPage>
  </DefaultLayout>
);
